import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useMatchMedia from 'hooks/useMatchMedia';
import { MembersDesktop } from './components/MembersDesktop';
import { MembersMobile } from './components/MembersMobile';
import { MOBILE_MEMBERS_ONE_SELECTOR } from 'router/subrouters/DataRoom/providers/Onboarding/data';

import './Members.styles.scss';
import './Members.styles.responsive.scss';

type MembersProps = {
  className?: string;
};

const Members: React.FC<MembersProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();
  const isTablet = useMatchMedia('isTablet');

  const classes = classNames('members', 'page', className);

  return (
    <div className={classes}>
      <h2 id={MOBILE_MEMBERS_ONE_SELECTOR}>{t('dataRoomMembers')}</h2>
      <p>{t(`dataRoomMembersDescription${isTablet ? 'Mobile' : ''}`)}</p>

      {isTablet ? <MembersMobile /> : <MembersDesktop />}
    </div>
  );
};

export default Members;
